import React from 'react';
import { useCustomComponent } from '@/hooks';

const LoadingDots: React.FC = () => (
  <div className="peptalk-loading-spinner">
    <div className="spinner-dot"></div>
    <div className="spinner-dot"></div>
    <div className="spinner-dot"></div>
  </div>
);

export const SubmitLoading: React.FC = () => {
  const Component = useCustomComponent({
    componentName: 'QuestionnaireSubmitLoading',
    Component: LoadingDots,
  });
  return <Component />;
};
